import { Link } from '@/ui-components/atoms/Link/Link';
import { Text } from '@/ui-components/atoms/Text/Text';
import { SnapshotAlertBanner } from './SnapshotAlertBanner';
import type { SnapshotAlertItem } from './SnapshotAlertPopover';
import styles from './snapshotpopover.module.scss';

interface SnapshotAlertListProps {
    alerts: SnapshotAlertItem[];
}

export function SnapshotAlertList({ alerts }: SnapshotAlertListProps): React.JSX.Element {
    return (
        <ul className={styles.snapshotAlertList}>
            {alerts.map((alert) => (
                <li key={alert.id}>
                    <div className={styles.snapshotDivider}>
                        <div className={styles.snapshotDividerLine} />
                    </div>
                    {alert.tone ? (
                        <SnapshotAlertBanner
                            ctaHref={alert.ctaHref}
                            ctaLabel={alert.ctaLabel}
                            message={alert.message}
                            tone={alert.tone}
                        />
                    ) : (
                        <div className={styles.snapshotAlertItem}>
                            <div className={styles.snapshotAlertItemCopy}>
                                <Text tag="p" className={styles.snapshotAlertItemMessage}>
                                    {alert.message}
                                </Text>
                            </div>
                            {alert.ctaLabel && (
                                <div className={styles.snapshotAlertItemActions}>
                                    <Link className={styles.snapshotAlertItemLink} href={alert.ctaHref || '#'}>
                                        {alert.ctaLabel}
                                    </Link>
                                </div>
                            )}
                        </div>
                    )}
                </li>
            ))}
        </ul>
    );
}
